module.exports = __webpack_public_path__ + "media/images/our_apps/header_mobile-9dd2aaf01eaf186e7aaa7c395296f229.png";